export var Result = {
    error: function (error) { return ({ error: error }); },
    ok: function (ok) { return ({ ok: ok }); },
    isError: function (value) {
        return Object.hasOwnProperty.call(value, 'error');
    },
    isOk: function (value) {
        return Object.hasOwnProperty.call(value, 'ok');
    }
};
